import React from 'react';
import { motion } from 'framer-motion';
import { footerVariants } from '../animations';

const Footer = () => {
  return (
    <motion.footer
      variants={footerVariants.footer}
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.3 }}>
      <div className='inner'>
        <div
          className='footer-top'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          viewport={{ once: true, amount: 0.3 }}>
          <div>
            <p className='address'>
              <span className='pc'>
                상호명: 주식회사 디엔소프트<br />
                사업자등록번호: 108-86-05434<br />
                대표자: 김성수<br />
                사업장 주소: 서울특별시 금천구 디지털로9길 46 이앤씨드림타워7차 608호
              </span>
              <span className='mo'>
                상호명: 주식회사 디엔소프트<br />
                대표자: 김성수<br />
                사업자등록번호: 108-86-05434<br />
                사업장 주소: 서울특별시 금천구 디지털로9길 46
                <br />
                이앤씨드림타워7차 608호
              </span>
            </p>
            <ul className='info'>
              <li>Mail: ask@dnsoft.co.kr</li>
              <li>Tel: 02-837-8313</li>
              <li>FAX: 02-6280-8326</li>
            </ul>
          </div>
          <div>
            <motion.ul
              className='icon-wrap'
              variants={footerVariants.icons}
              initial='hidden'
              whileInView='visible'
              viewport={{ once: true }}>
              <motion.li variants={footerVariants.icon}>
                <a
                  href='https://naver.me/G7Z2wXTB'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='네이버지도'>
                  <svg
                    width='48'
                    height='48'
                    viewBox='0 0 48 48'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M24 0C13.524 0 5.00019 8.6136 5.00019 19.188C4.93132 34.656 23.278 47.4816 24 48C24 48 43.0687 34.656 42.9998 19.2C42.9998 8.6136 34.476 0 24 0ZM24 28.8C18.7513 28.8 14.5001 24.504 14.5001 19.2C14.5001 13.896 18.7513 9.6 24 9.6C29.2487 9.6 33.4999 13.896 33.4999 19.2C33.4999 24.504 29.2487 28.8 24 28.8Z'
                      fill='white'
                    />
                  </svg>
                </a>
              </motion.li>
              <motion.li variants={footerVariants.icon}>
                <a href='mailto:ask@dnsoft.co.kr' aria-label='메일보내기'>
                  <svg
                    width='48'
                    height='48'
                    viewBox='0 0 48 48'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M7.5 5C5.51088 5 3.60322 5.78195 2.1967 7.17382C0.790176 8.56569 0 10.4535 0 12.4219V35.5781C0 37.5465 0.790176 39.4343 2.1967 40.8262C3.60322 42.2181 5.51088 43 7.5 43H40.5C42.4891 43 44.3968 42.2181 45.8033 40.8262C47.2098 39.4343 48 37.5465 48 35.5781V12.4219C48 10.4535 47.2098 8.56569 45.8033 7.17382C44.3968 5.78195 42.4891 5 40.5 5H7.5ZM3 12.4219C3 11.2408 3.47411 10.1082 4.31802 9.27304C5.16193 8.43792 6.30653 7.96875 7.5 7.96875H40.5C41.6935 7.96875 42.8381 8.43792 43.682 9.27304C44.5259 10.1082 45 11.2408 45 12.4219V13.4788L24.0024 24.4156L3 13.3873V12.4219ZM3 16.7491L23.2968 27.4058C23.5126 27.519 23.753 27.5785 23.9973 27.5789C24.2416 27.5793 24.4822 27.5207 24.6984 27.4081L45 16.8334V35.5781C45 36.7592 44.5259 37.8918 43.682 38.727C42.8381 39.5621 41.6935 40.0312 40.5 40.0312H7.5C6.30653 40.0312 5.16193 39.5621 4.31802 38.727C3.47411 37.8918 3 36.7592 3 35.5781V16.7491Z'
                      fill='white'
                    />
                  </svg>
                </a>
              </motion.li>
              <motion.li variants={footerVariants.icon}>
                <a
                  href='https://youtube.com/@dnsoft4373'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='유튜브'>
                  <svg
                    width='48'
                    height='48'
                    viewBox='0 0 48 48'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M24 5C26.052 5 28.1568 5.0528 30.1968 5.1392L32.6064 5.2544L34.9128 5.3912L37.0728 5.5376L39.0456 5.6912C41.1868 5.85414 43.2019 6.76744 44.7359 8.27024C46.2699 9.77305 47.2243 11.7689 47.4312 13.9064L47.5272 14.9264L47.7072 17.1104C47.8752 19.3736 48 21.8408 48 24.2C48 26.5592 47.8752 29.0264 47.7072 31.2896L47.5272 33.4736L47.4312 34.4936C47.2243 36.6314 46.2694 38.6276 44.735 40.1305C43.2005 41.6333 41.1849 42.5464 39.0432 42.7088L37.0752 42.86L34.9152 43.0088L32.6064 43.1456L30.1968 43.2608C28.1324 43.3502 26.0663 43.3966 24 43.4C21.9337 43.3966 19.8676 43.3502 17.8032 43.2608L15.3936 43.1456L13.0872 43.0088L10.9272 42.86L8.9544 42.7088C6.81315 42.5459 4.79808 41.6326 3.26411 40.1298C1.73013 38.6269 0.775658 36.631 0.5688 34.4936L0.4728 33.4736L0.2928 31.2896C0.109999 28.9307 0.0123351 26.566 0 24.2C0 21.8408 0.1248 19.3736 0.2928 17.1104L0.4728 14.9264L0.5688 13.9064C0.775577 11.7693 1.72971 9.77373 3.26319 8.27097C4.79667 6.76822 6.81118 5.85468 8.952 5.6912L10.9224 5.5376L13.0824 5.3912L15.3912 5.2544L17.8008 5.1392C19.866 5.04975 21.9329 5.00333 24 5ZM19.2 18.38V30.02C19.2 31.1288 20.4 31.82 21.36 31.268L31.44 25.448C31.6593 25.3217 31.8415 25.1399 31.9682 24.9208C32.0949 24.7017 32.1616 24.4531 32.1616 24.2C32.1616 23.9469 32.0949 23.6983 31.9682 23.4792C31.8415 23.2601 31.6593 23.0783 31.44 22.952L21.36 17.1344C21.141 17.008 20.8926 16.9414 20.6398 16.9415C20.3869 16.9415 20.1385 17.0081 19.9196 17.1346C19.7007 17.2611 19.5189 17.443 19.3926 17.6621C19.2663 17.8811 19.1998 18.1295 19.2 18.3824V18.38Z'
                      fill='white'
                    />
                  </svg>
                </a>
              </motion.li>
              <motion.li variants={footerVariants.icon}>
                <a
                  href='https://www.instagram.com/argong.ai/'
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label='인스타그램'>
                  <svg
                    width='48'
                    height='48'
                    viewBox='0 0 48 48'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M23.9999 33.7782C26.5932 33.7782 29.0802 32.7481 30.9139 30.9144C32.7476 29.0807 33.7777 26.5937 33.7777 24.0004C33.7777 21.4072 32.7476 18.9202 30.9139 17.0865C29.0802 15.2528 26.5932 14.2227 23.9999 14.2227C21.4067 14.2227 18.9197 15.2528 17.086 17.0865C15.2523 18.9202 14.2222 21.4072 14.2222 24.0004C14.2222 26.5937 15.2523 29.0807 17.086 30.9144C18.9197 32.7481 21.4067 33.7782 23.9999 33.7782Z'
                      stroke='white'
                      strokeWidth='3'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M2 33.7778V14.2222C2 10.9807 3.28769 7.87192 5.57981 5.57981C7.87192 3.28769 10.9807 2 14.2222 2H33.7778C37.0193 2 40.1281 3.28769 42.4202 5.57981C44.7123 7.87192 46 10.9807 46 14.2222V33.7778C46 37.0193 44.7123 40.1281 42.4202 42.4202C40.1281 44.7123 37.0193 46 33.7778 46H14.2222C10.9807 46 7.87192 44.7123 5.57981 42.4202C3.28769 40.1281 2 37.0193 2 33.7778Z'
                      stroke='white'
                      strokeWidth='3'
                    />
                    <path
                      d='M37.4443 10.5796L37.4688 10.5527'
                      stroke='white'
                      strokeWidth='3'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </a>
              </motion.li>
            </motion.ul>
          </div>
        </div>

        <motion.div
          className='footer-bottom'
          variants={footerVariants.bottom}
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true }}>
          <ul>
            <li>
              <a href='/ai-ethics'>AI 윤리원칙</a>
            </li>
            |
            <li>
              <a href='/privacy'>개인정보처리방침</a>
            </li>
          </ul>
          <motion.div
            className='footer-border'
            variants={footerVariants.border}
            initial='hidden'
            whileInView='visible'
            viewport={{ once: true }}></motion.div>
          <span>© 2024 DNSOFT. All rights reserved.</span>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
